import http from './http.js'
import store from './store.js'
import { createRouter, createWebHistory } from 'vue-router'
import { BASE_URL } from '@/configs/xhconfig'

const router = createRouter({
    history: createWebHistory(BASE_URL),
    routes: [
        {
            path: '/delivery',
            component: () => import('./pages/Delivery/Page.vue'),
            meta: { title: '心意投递', auth: true }
        },
        {
            path: '/delivery/submit',
            component: () => import('./pages/DeliverySubmit/Page.vue'),
            meta: { title: '心意投递', auth: true }
        },
        {
            path: '/activity',
            component: () => import('./pages/Activity/Page.vue'),
            meta: { title: '活动专区', auth: true }
        },
        {
            path: '/activity/:id',
            component: () => import('./pages/ActivityDetail/Page.vue'),
            meta: { title: '活动详情', auth: true }
        },
        {
            path: '/invitation',
            component: () => import('./pages/Invitation/Page.vue'),
            meta: { title: '邀请记录', auth: true }
        },
        {
            path: '/welfare',
            component: () => import('./pages/Welfare/Page.vue'),
            meta: { title: '权益中心', auth: true }
        },
        {
            path: '/welfare/:id',
            component: () => import('./pages/WelfareDetail/Page.vue'),
            meta: { title: '填写信息', auth: true }
        },
        {
            path: '/agreement/:type',
            component: () => import('./pages/Agreement/Page.vue'),
            meta: {title: '关于我们'}
        },
        {
            path: '/ticket',
            component: () => import('./pages/Ticket/Page.vue'),
            meta: {title: '支付结果'}
        },
        {
            path: '/auth',
            component: () => import('./pages/Auth/Page.vue'),
            meta: {title: '实名认证', auth: true}
        },
        {
            path: '/cashier/:id',
            component: () => import('./pages/Cashier/Page.vue'),
            meta: {title: '订单支付', auth: true}
        },
        {
            path: '/payment/:id',
            component: () => import('./pages/Payment/Page'),
            meta: {title: '订单支付', auth: true}
        },
        {
            path: '/card',
            component: () => import('./pages/Card/Page.vue'),
            meta: {title: '我的卡券', auth: true}
        },
        {
            path: '/login',
            component: () => import('./pages/Login/Page.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/album',
            component: () => import('./pages/Album/Page.vue'),
            meta: { title: '专辑' }
        },
        {
            path: '/',
            component: () => import('./pages/Index/Page.vue'),
            meta: { title: '首页' }
        },
        {
            path: '/order',
            component: () => import('./pages/Order/Page.vue'),
            meta: { title: '我的订单', auth: true }
        },
        {
            path: '/market',
            component: () => import('./pages/Market/Page.vue'),
            meta: { title: '市场' }
        },
        {
            path: '/entity',
            component: () => import('./pages/Entity/Page.vue'),
            meta: { title: '我的藏品', auth: true }
        },
        {
            path: '/search',
            component: () => import('./pages/Search/Page.vue'),
            meta: { title: '搜索' }
        },
        {
            path: '/product/:id/compose',
            component: () => import('./pages/Compose/Page.vue'),
            meta: { title: '合成列表' }
        },
        {
            path: '/personal',
            component: () => import('./pages/Personal/Page.vue'),
            // meta: { title: '个人中心', auth: true }
        },
        {
            path: '/subscribe',
            component: () => import('./pages/Subscribe/Page.vue'),
            meta: { title: '我的订阅', auth: true }
        },
        {
            path: '/album/:id',
            component: () => import('./pages/AlbumDetail/Page.vue'),
            meta: { title: '专辑详情' }
        },
        {
            path: '/entity/:id',
            component: () => import('./pages/EntityDetail/Page.vue'),
            meta: { title: '藏品详情' }
        },
        {
            path: '/organization',
            component: () => import('./pages/Organization/Page.vue'),
            meta: { title: '机构' }
        },
        {
            path: '/organization/:id',
            component: () => import('./pages/OrganizationDetail/Page.vue'),
            meta: { title: '机构详情' }
        },
        {
            path: '/calendar',
            component: () => import('./pages/Calendar/Page.vue'),
            meta: { title: '发售日历' }
        },
        {
            path: '/notice',
            component: () => import('./pages/Notice/Page.vue'),
            meta: { title: '消息中心', auth: true }
        },
        {
            path: '/about',
            component: () => import('./pages/About/Page.vue'),
            meta: { title: '关于我们' }
        },
        {
            path: '/compose/:id',
            component: () => import('./pages/ComposeDetail/Page.vue'),
            meta: { title: '合成详情' }
        },
        {
            path: '/product/:id',
            component: () => import('./pages/ProductDetail/Page.vue'),
            meta: { title: '新华数藏·藏品详情' }
        }
    ]
})

router.beforeEach((to, from, next) => {
    http.post('visit').then(result => {
        if (! result.data.spread) {
            store.commit('setSpread', null);
        }
    });
    if (to.meta.auth && store.state.authorizationTime < new Date().getTime()) {
        /* eslint-disable */
        appContext.config.globalProperties.login(to.fullPath);
        /* eslint-enable */
    } else {
        next();
    }
})

// 路由守卫，设置文档title信息
router.afterEach((to) => {
    document.title = to.meta.title ? to.meta.title : '';
    setTimeout(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.pageYOffset = 0;
    }, 100)
})

export default router